export default "__VITE_PUBLIC_ASSET__32b96fbe__"